module.exports = __webpack_public_path__ + "Variables.af69ccc43abe381b6fac8d38b3351ac4.hashedasset.svg";